/* Closed-enum badges: run status, outcome status, capability origin,
 * operation type. Colors map the closed sets — never free-form. */
import React from 'react';
import type {
    Outcome
} from '../api/types';

const RUN_TONE: Record<string, string> = {
    running: 'info',
    waiting: 'warning',
    completed: 'success',
    cancelled: 'neutral'
};

export function RunStatusBadge({
    status
}: {
    status?: string;
}) {
    const s = String(status || 'unknown');
    const tone = RUN_TONE[s] || 'neutral';
    return <span className={`aps-badge aps-badge-${tone}`}>{s}</span>;
}

/** Outcome badge — green when ok, red otherwise; shows the closed status. */
export function OutcomeBadge({
    outcome
}: {
    outcome?: Outcome | null;
}) {
    if (!outcome) return <span className="aps-badge aps-badge-neutral">no outcome</span>;
    const tone = outcome.ok ? 'success' : 'danger';
    return (
        <span className={`aps-badge aps-badge-${tone}`}>
            {outcome.ok ? 'ok' : 'failed'} · {String(outcome.status || '?')}
        </span>
    );
}

const ORIGIN_TONE: Record<string, string> = {
    ingested: 'info',
    modified: 'warning',
    manual: 'violet'
};

/** The origin rule (locked): ingested · modified · manual. */
export function OriginChip({
    origin
}: {
    origin?: string;
}) {
    const o = String(origin || 'ingested');
    const tone = ORIGIN_TONE[o] || 'neutral';
    return <span className={`aps-badge aps-badge-${tone}`}>{o}</span>;
}

const RISK_TONE: Record<string, string> = {
    safe: 'success',
    low: 'success',
    medium: 'warning',
    write: 'warning',
    high: 'danger',
    destructive: 'danger'
};

export function RiskBadge({
    level
}: {
    level?: string;
}) {
    if (!level) return null;
    const tone = RISK_TONE[level] || 'neutral';
    return <span className={`aps-badge aps-badge-${tone}`}>{level}</span>;
}

const OP_TONE: Record<string, string> = {
    create: 'success',
    update: 'warning',
    delete: 'danger',
    action: 'violet'
};

export function OperationTypeBadge({
    type
}: {
    type?: string;
}) {
    if (!type) return null;
    const tone = OP_TONE[type] || 'neutral';
    return <span className={`aps-badge aps-badge-${tone}`}>{type}</span>;
}
